import { CdkStepper, CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'lib-stepper',
  imports: [CommonModule, NgTemplateOutlet, CdkStepperModule, MatButtonModule],
  template: `
    <div title class="title-container">
      <span class="mat-headline-medium title">
        {{ stepper.selected?.label }}
      </span>
      <span class="mat-title-large stepper">
        Step {{ stepper.selectedIndex + 1 }} of {{ stepper.steps.length }}
      </span>
    </div>

    <p class="mat-body-large" [innerHtml]="stepper.selected?.state"></p>

    <ng-container
      [ngTemplateOutlet]="stepper.selected ? stepper.selected.content : null"
    />
  `,
  styles: `
    @use '@angular/material' as mat;
    @use 'theme' as theme;

    .title-container {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title {
        margin: 0;
        color: mat.get-theme-color(theme.$light-theme, on-surface);
      }

      .stepper {
        color: mat.get-theme-color(theme.$light-theme, on-primary-fixed);
        flex-shrink: 0;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [{ directive: CdkStepper, inputs: ['linear'] }],
})
export class StepperComponent {
  stepper = inject(CdkStepper);
}
